(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baggy-editorial-footer"] && !Shopify.designMode) return;
  try {
    
function baggyFooterAccordions(root=document){root.querySelectorAll('.be-footer details').forEach(d=>{d.open=!matchMedia('(max-width:749px)').matches;});}baggyFooterAccordions();document.addEventListener('shopify:section:load',e=>baggyFooterAccordions(e.target));matchMedia('(max-width:749px)').addEventListener('change',()=>baggyFooterAccordions());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baggy-editorial-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('baggy-flip-init')){customElements.define('baggy-flip-init',class extends HTMLElement{});document.addEventListener('click',event=>{const button=event.target.closest('.be-card__flip');if(!button)return;const card=button.closest('.be-card');const active=card.toggleAttribute('data-back');button.setAttribute('aria-pressed',String(active));});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baggy-editorial-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('play',event=>{if(!event.target.matches('.be-video video'))return;document.querySelectorAll('.be-video video').forEach(video=>{if(video!==event.target)video.pause();});},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
